import { uniqueValidator } from 'functions/validation';
import {  STATIC_TABLE_SETTINGS } from 'store/reducers/constants/constants.js';


//function used to help sort columns
export const compareValues = (a, b, ascending=true) => {
  if (!a) {
    return 1
  } else if (!b) {
    return -1
  }

  if (typeof(a) === 'number' || parseFloat(a)) {
    if (ascending) {
      return a - b
    } else {
      return b - a
    }
  } else if (ascending) {
    return a.localeCompare(b)
  } else {
    return b.localeCompare(a)
  }
}

export  const getMax = (arr, colName) => {
    // No rows to take a max over. Return null (not a fake row) so callers can
    // detect "nothing yet" — getDefaultValue's `if (!maxRow) return 1` relies on
    // this to seed the first auto-increment id. The previous `{colName: 1}` was
    // a malformed object (a literal "colName" key, not the requested column), so
    // that guard never fired and `maxRow[columnName] + 1` computed `NaN`.
    if (!arr || arr.length === 0) { return null }
    let max;
    for (const row of arr) {
      if (max == null || parseInt(row[colName]) > parseInt(max[colName]))
        max = row;
    }
    return max;
}

export const getDefaultValue = (state, tableName, columnName) => {
  const defaultValue = STATIC_TABLE_SETTINGS[tableName]['defaultValue'][columnName];
  if (defaultValue || defaultValue === false || defaultValue === 0) {
    if (defaultValue === 'increment') {
      const maxRow = getMax(state['data'][tableName], columnName)
      if (!maxRow) {
        return 1
      }
      return maxRow[columnName] + 1;
    } 
    
    else if (defaultValue === 'today') {
      return new Date().toLocaleDateString();
    }

    else if (defaultValue === 'all') {
      let uniqueValues;
      const dropdownSource = STATIC_TABLE_SETTINGS[tableName]['dropdownSource'][columnName]
        if (dropdownSource) {
          const dropdownTableName = dropdownSource.tableName
          const dataColumn = dropdownSource['column']
          uniqueValues = [...new Set(state['data'][dropdownTableName].map(row => {return row[dataColumn]}))];
        } else {
          const errorMessage = 'Expecting a dropdown source when default value "all" is supplied for column: ' + columnName + ' of table: ' + tableName
          throw new Error(errorMessage);
        }
      return uniqueValues
    }

    else {
      return defaultValue;
    }
  }
  return null
}


/**
 * helper function that will adjust the name of a unique validation item if it is not unique
 * @param {} args 
 */
export const uniqueValidationHelper = (args) => {
  let validation = uniqueValidator({newValue:args.newValue, data:args.data, row:args.row, columnName:args.columnName, entered:args.entered})
  let initialValid = true;
  let adjNewValue = null;
  if (!validation.valid) {
    let adder = 1
    while (true) {
      adjNewValue = args.newValue + ' (' + String(adder) + ')'
      validation = uniqueValidator({newValue:adjNewValue, data:args.data, row:args.row, columnName:args.columnName, entered:false})
      if (validation.valid) {
        break
      } else {
        adder += 1;
      }
    }
    initialValid = false;
  }
  return [initialValid, adjNewValue];
}